import { lazy } from 'react';
import { UserTypes } from '@/configs/AppConfig';
import { MOD_SYSTEM_USER } from '@/configs/ModulesConfig';
import { Navigate } from "react-router-dom";

const SystemUserList = lazy(() => import('./SystemUserList'));


const route = [
    {
        path: MOD_SYSTEM_USER.base_path,
        element: <Navigate to={MOD_SYSTEM_USER.routes.list} replace />,
        auth: MOD_SYSTEM_USER.auth
    },
    {
        path: MOD_SYSTEM_USER.routes.list,
        element: <SystemUserList />,
        auth: MOD_SYSTEM_USER.auth
    },
];



export default route;